import React from 'react';
import './style.css';
import Popup from "reactjs-popup";
//add a form in the modal later
const Button = (props)  => {
       return ( 
    <Popup trigger={<button className='advice'>{props.name}</button>}
    modal
    closeOnDocumentClick
    >
    <span className='email'> Email me at e@chidwi.com </span>
    </Popup>
       
    );
}
export default Button;


// WEBPACK FOOTER //
// ./src/components/Button.js